import { useIsFocused } from "@react-navigation/native";
import React, { useEffect, useRef } from "react";
import { Animated } from "react-native";
import { withAnchorPoint } from "react-native-anchor-point";

const AnimatedBar = ({
  onCompleteAnimation,
  index,
  currentImage,
  pause,
  duration,
  maxWidth,
}) => {
  const barTransFormX = useRef(new Animated.Value(0));
  const barAnimation = Animated.timing(barTransFormX.current, {
    toValue: 100,
    duration: duration || 5000,
    useNativeDriver: true,
  });
  const fadeAnim = useRef(new Animated.Value(0)).current;

  const isFocused = useIsFocused();

  React.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 100,
      useNativeDriver: true,
    }).start();
  }, [fadeAnim]);

  useEffect(() => {
    if (index === currentImage && !pause) {
      barAnimation.start(({ finished }) => {
        if (finished) {
          onCompleteAnimation();
        }
      });
    } else if (pause || !isFocused) {
      barAnimation.stop();
    } else {
      Animated.timing(barTransFormX.current, {
        toValue: 0,
        duration: 0,
        useNativeDriver: true,
      }).start();
    }
  }, [
    index,
    currentImage,
    barAnimation,
    onCompleteAnimation,
    pause,
    isFocused,
  ]);

  const scaleX = barTransFormX.current.interpolate({
    inputRange: [0, 100],
    outputRange: [0, 1],
  });

  const getTransform = () => {
    const transform = {
      transform: [{ scaleX: currentImage > index ? 1 : scaleX }],
    };
    return withAnchorPoint(
      transform,
      { x: 0, y: 0 },
      { width: maxWidth, height: 2 },
    );
  };

  return (
    <Animated.View
      style={{
        height: 2,
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        borderRadius: 10,
        overflow: "hidden",
        opacity: fadeAnim,
        flexDirection: "row",
      }}
    >
      <Animated.View
        style={[
          {
            height: 2,
            width: maxWidth,
            backgroundColor: "#fff",
          },
          getTransform(),
        ]}
      />
    </Animated.View>
  );
};

export default AnimatedBar;
